import { Injectable } from "@angular/core";
import { AuthenticationService } from "@common/services";

import { app, authentication } from "@microsoft/teams-js";

@Injectable({
  providedIn: "root",
})
export class TeamsAuthService {
  constructor() {}

  /**
   * Login by Microsoft Teams
   * @returns Promise
   */
  login(): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        app.initialize().then(() => {
          app.getContext().then(async (context) => {
            // Si obtuvo el contexto
            if (context){
              // Busca obtener el valor del token
              let token = await this.getClientSideToken();
              // Retorna el token obtenido
              resolve(token);
            }
          });
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  // 1. Get auth token
  // Ask Teams to get us a token from AAD
  private getClientSideToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      authentication
      .getAuthToken()
      .then((value) => {
        resolve(value);
      })
      .catch((error) => {
        reject( "Error getting token: " + error);
      });
    }); 
  }
}
